export const errorMessages = {
  serverBusy: 'Our system is a bit busy at the moment. Please give another try later.',
  unexpectedError: 'Oops, an unexpected error occured.',
}
